import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { redMui } from "@ryde/theme";

const ErrorDisplayRemoveRelationStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "error-display-remove-relation",
})`
  padding-block: 16px;
  font-size: 1rem;

  .relation-warning-message {
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.00938em;
    color: ${redMui._700};
  }

  .confirm-message-text {
    margin-top: 8px;
  }
`;

interface IErrorDisplayRemoveRelationProps {
  confirmMessage?: string;
  relationWarningMessage: string;
}

export const ErrorDisplayRemoveRelation = ({
  relationWarningMessage,
  confirmMessage = `general.ENTITY_RELATED_ARCHIVED_CONFIRM`,
}: IErrorDisplayRemoveRelationProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <ErrorDisplayRemoveRelationStyled>
      <div className="relation-warning-message">{relationWarningMessage}</div>
      {confirmMessage && (
        <div className="confirm-message-text">{t(confirmMessage)}</div>
      )}
    </ErrorDisplayRemoveRelationStyled>
  );
};
